import React from 'react';
import { CalendarIcon, PhoneIcon, TrendingDownIcon } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-154">
      <div className="max-w-4xl mx-auto px-4" data-id="element-155">
        {/* Emotional Hook */}
        <div className="mb-16" data-id="element-156">
          <h2 className="font-heading text-3xl md:text-5xl text-blueprint-blue mb-8 text-center" data-id="element-157">
            Sé exactamente cómo te sientes ahora mismo.
          </h2>

          <div className="prose prose-lg md:prose-xl max-w-none text-industrial-gray leading-relaxed space-y-6" data-id="element-158">
            <p data-id="element-159">
              Miras el calendario del próximo mes y está en blanco. Miras a tus
              trabajadores a los ojos y sientes el peso de no saber si tendrás
              horas para darles. Abres la cuenta del banco y ves que el flujo se
              está secando, mientras que la renta de la bodega y el pago de la
              camioneta no perdonan.
            </p>
          </div>
        </div>

        {/* Failed Attempts */}
        <div className="mb-16" data-id="element-160">
          <h3 className="font-heading text-2xl md:text-4xl text-blueprint-blue mb-8" data-id="element-161">
            Has intentado de todo:
          </h3>

          <div className="space-y-6" data-id="element-162">
            <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-lg border-l-4 border-construction-orange" data-id="element-163">
              <CalendarIcon className="w-8 h-8 text-construction-orange flex-shrink-0 mt-1" aria-hidden="true" data-id="element-164" />
              <div data-id="element-165">
                <p className="text-lg md:text-xl text-industrial-gray" data-id="element-166">
                  Esperar a que "Don Juan" te recomiende{' '}
                  <span className="text-gray-500 italic" data-id="element-167">
                    (pero él no tiene prisa)
                  </span>
                  .
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-lg border-l-4 border-construction-orange" data-id="element-168">
              <TrendingDownIcon className="w-8 h-8 text-construction-orange flex-shrink-0 mt-1" aria-hidden="true" data-id="element-169" />
              <div data-id="element-170">
                <p className="text-lg md:text-xl text-industrial-gray" data-id="element-171">
                  Pagar por leads en plataformas famosas{' '}
                  <span className="text-gray-500 italic" data-id="element-172">
                    (donde compites con 10 personas que cobran más barato)
                  </span>
                  .
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-lg border-l-4 border-construction-orange" data-id="element-173">
              <PhoneIcon className="w-8 h-8 text-construction-orange flex-shrink-0 mt-1" aria-hidden="true" data-id="element-174" />
              <div data-id="element-175">
                <p className="text-lg md:text-xl text-industrial-gray" data-id="element-176">
                  Publicar en Facebook sin que nadie te responda.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Truth Bomb */}
        <div className="bg-construction-orange text-white p-8 md:p-12 rounded-lg text-center" data-id="element-177">
          <h3 className="font-heading text-3xl md:text-5xl mb-4" data-id="element-178">
            La verdad es ruda:
          </h3>
          <p className="text-2xl md:text-3xl font-bold" data-id="element-179">
            Si dependes de la suerte, tu negocio ya está muerto.
          </p>
        </div>
      </div>
    </section>;
}